// extracted by mini-css-extract-plugin
export default {"classroom-navigation":"navigation-module_classroom-navigation_yNPSV_hy","classroom-list":"navigation-module_classroom-list_BiskAuvn"};